import {cloneElement, isValidElement} from "react";
import {Immutable, ImmutableObject, Mutable} from "@witivio_teamspro/use-reducer";

const deepClone = <T>(source: Immutable<T>): Mutable<T> => {
    if (source === null || typeof source !== 'object') return source as any;
    if (isValidElement(source)) return cloneElement(source) as any;
    if (Array.isArray(source)) return source.map((item) => deepClone(item)) as any;
    const clonedObj = {} as any;
    for (const key in source) {
        // @ts-ignore
        if (source.hasOwnProperty(key)) clonedObj[key] = deepClone(source[key]);
    }
    return clonedObj as any;
}

const clearNullValues = <T extends object>(object: T) => {
    for (const [key, value] of Object.entries(object)) {
        const property = key as keyof T;
        if (value === null) delete object[property];
    }
    return object;
}

const isISODateString = (value: any): boolean => {
    return typeof value === 'string' && !isNaN(Date.parse(value));
}

const convertDates = <T>(item: T): T => {
    if (typeof item !== 'object' || !item) return item;
    if (Array.isArray(item)) return item.map(item => convertDates(item)) as T;
    const result: any = {};
    for (const key in item) {
        if (item.hasOwnProperty(key)) {
            const value = (item as any)[key];
            if (isISODateString(value)) {
                result[key] = new Date(value);
            } else if (typeof value === 'object') {
                result[key] = convertDates(value);
            } else {
                result[key] = value;
            }
        }
    }
    return result as T;
}

const filterByProperties = <T extends object>(
    properties: (keyof T)[]
) => (
    items: readonly ImmutableObject<ImmutableObject<T>>[] | undefined,
    filter: string,
): Immutable<T>[] => {
    const lowerFilter = filter.toLowerCase();
    return items?.filter(i => {
        for (let j = 0; j < properties.length; j++) {
            const property = properties[j];
            if (property) {
                const value = ((i[property] ?? "") + "").toLowerCase();
                if (value.includes(lowerFilter)) return true;
            }
        }
        return false;
    }) as Immutable<T>[];
}

export const ObjectModule = {
    deepClone,
    clearNullValues,
    convertDates,
    filterByProperties
}